module.exports = __webpack_public_path__ + "img/map-option-jishou.b43ba2e0.png";